import logger from './logger'

const getRequest = async <T>(
	url: string,
	name: string,
	args?: RequestInit
): Promise<T> => {
	let response: Response

	try {
		/**
		 * NOTE: Formatted as a ternary to avoid tests thinking fetch is called with url, {} or url, undefined
		 */
		response = args ? await fetch(url, { ...args }) : await fetch(url)

		if (!response.ok) {
			throw new Error(response.status.toString())
		}

		const data: T = await response.json()

		return data
	} catch (error) {
		logger(`Error retrieving ${name.toLocaleLowerCase()} data`, error, {
			errorType: name,
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
	}
}

export default getRequest
